<script setup>

import {defineProps} from "vue";

const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  }
});

</script>

<template>
  <div v-if="props.loading" class="loader-container">
    <h2>Cargando</h2>


    <div class="loader">

      <div class="loader-point"></div>
      <div class="loader-point"></div>
      <div class="loader-point"></div>
    </div>
  </div>


</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lobster&display=swap');
.loader-container {
  height: 100vh;
  background-color: #FD8204;
  display: flex;
  color: #ffffff;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-family: "Lobster";
  h2 {
    font-family: "Lobster";
    font-size: 3rem;
  }
  img{
    width: 50%;
  }
}
.loader{
  display: flex;
  justify-content: center;
  align-self: center;
  margin: 0 auto;
  font-family: "Lobster";
}

.loader-point{
  width: 1.5rem;
  height: 1.5rem;
  margin: 3rem .5rem;
  border-radius: 50%;
  background-color: #ffffff;
  animation: loader .6s infinite alternate;
}

@keyframes loader {
  to{
    opacity: .1;
    transform: translate3d(0, -1rem, 0);
  }
}

.loader-point:nth-child(2){
  animation-delay: .2s;
}

.loader-point:nth-child(3){
  animation-delay: .4s;
}
</style>
